import VueRouter from 'vue-router'
import authenticationGuard from './authenticationGuard'
import authorizationGuard from './authorizationGuard'
import contentTreeGuard from './contentTreeGuard'
import signedInPlatformGuard from './signedInPlatformGuard'
import authenticationStore from '@/store/modules/authentication.store'
import { routerState } from '../utils'

export default async (to, from, next) => {
  VueRouter.prototype.previousRoute = from

  const authenticationGuardState = await authenticationGuard(to, from, next)
  if (authenticationGuardState !== routerState.ALLOWED) {
    return
  }

  const isUserAuthenticated = authenticationStore.state.authenticated
  const authorizationGuardState = isUserAuthenticated ? await authorizationGuard(to, from, next) : routerState.ALLOWED
  if (authorizationGuardState !== routerState.ALLOWED) {
    return
  }

  const signedInPlatformGuardState = isUserAuthenticated ? await signedInPlatformGuard(to, from, next) : routerState.ALLOWED
  if (signedInPlatformGuardState !== routerState.ALLOWED) {
    return
  }

  await contentTreeGuard(to)
  next()
}
